import { FactoryProvider, InjectionToken } from '@angular/core';

import { AppConfig } from '@app/app.config';
import { IntegrationsService } from '@app/integrations/services/integrations.service';
import { generateDefaultLimitWarningsConfig } from '@main/components/limits-notification/limits-notification.config';
import { LimitsConfig } from '@main/components/limits-notification/limits-notification.types';
import { generatePackageLimitWarningsConfig } from '@main/components/limits-notification/package-limits-notification.config';
import { ICountLimit } from '@shared/interfaces/ITokenPackage';

import { AccountService } from '../../shared/services/account';

export type limitsMessageConfigCtor = (
    maxCountLimit?: ICountLimit,
    caption?: string,
    isUpgradable?: boolean,
) => LimitsConfig;

export const LIMIT_MESSAGE_CONFIG = new InjectionToken<limitsMessageConfigCtor>('LIMIT_MESSAGE_CONFIG');

export function limitsMessageConfigFactory(
    appConfig: AppConfig,
    accountService: AccountService,
    integrationsService: IntegrationsService,
): () => limitsMessageConfigCtor {
    return () =>
        integrationsService.isIntegration() && appConfig.appInfo.integrationHasPackages
            ? integrationsService.getService().getLimitWarningsConfig()
            : accountService.currentUser.hasPackage
              ? generatePackageLimitWarningsConfig
              : generateDefaultLimitWarningsConfig;
}

export const LIMITS_MESSAGE_CONFIG_PROVIDER: FactoryProvider = {
    provide: LIMIT_MESSAGE_CONFIG,
    useFactory: limitsMessageConfigFactory,
    deps: [AppConfig, AccountService, IntegrationsService],
};
